import React, { useRef } from "react";
import Cards from "../components/Cards";
import Footer from "../components/Footer";
import OurStory from "../components/OurStory";
import Navbar from "../components/navbar/GuideNavbar";
import { useState } from "react";
import SubNew from "../components/SubNew";
import Access from "../components/Access";
import GuideInfo from "../components/form/ToolGuideInfo";
import ChatInfo from "../components/form/ToolChatInfo";
import WhyUsPage from "../components/WhyUsPage";
// import Deliverables from '../components/Deliverables';
import ProfesionalValue from "../components/ProfesionalValue";
import GuideModal from "../components/modal/guideModal/guideModal";
// import Whyusd from '../components/Whyusd';

const Guide = () => {
  const [clicked, isClicked] = useState(false);
  //   const modalRef = useRef();
  //   const handleModal = () => {
  //     modalRef.current.openModal();
  //   }

  return (
    <div className="overflow-hidden">
      <Navbar
      // clicked={clicked}
      // isClicked={isClicked}
      // handleModal={handleModal}
      // modalRef={modalRef}
      />
      {/* <div className="flex flex-col"> */}
      <Access readTime={"5 Minutes Read"} />
      <GuideInfo />
      {clicked && <ChatInfo />}
      {/* </div> */}

      {/* <WhyUs /> */}
      {/* <WhyUsPage /> */}
      {/* <Cards /> */}
      {/* <ProfesionalValue /> */}
      {/* <Deliverables /> */}
      {/* <OurStory /> */}
      <SubNew />
      <Footer />
      {<GuideModal />}
    </div>
  );
};

export default Guide;
